import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { ETLExecutionModeEnum, ETLJobRecurrenceEnum } from '~/api/types';

const ExecutionModeField = () => {
  const {
    control,
    setValue,
    watch,
    formState: { touchedFields },
  } = useFormContext();
  const executionMode = watch('execution_mode');

  useEffect(() => {
    if (!touchedFields.execution_mode) return;

    setValue('end_date', null);
    setValue('start_date', null);
    setValue('time', null);
    if (executionMode === ETLExecutionModeEnum.ON_DEMAND) setValue('frequency', null);
    else setValue('frequency', ETLJobRecurrenceEnum.NOT_REPEAT);
  }, [executionMode, setValue]);

  return (
    <FormControlLabel
      label="EXECUTION MODE"
      sx={{ width: 'fit-content' }}
      required
      control={
        <Controller
          name="execution_mode"
          control={control}
          render={({ field }) => (
            <RadioGroup row {...field}>
              <FormControlLabel
                labelPlacement="end"
                value={ETLExecutionModeEnum.ON_DEMAND}
                control={<Radio size="small" />}
                label="On Demand"
              />
              <FormControlLabel
                labelPlacement="end"
                value={ETLExecutionModeEnum.SCHEDULE}
                control={<Radio size="small" />}
                label="Schedule"
              />
            </RadioGroup>
          )}
        />
      }
    />
  );
};

export default ExecutionModeField;
